import { computed, ref, watch } from 'vue';
import { useUserStore } from '@/stores/pinia/useUserStore';

export function useVerifyEmail() {
	const userStore = useUserStore();

	const showBanner = ref(false);

	const userCreationTime = computed(() => userStore.userInfo.creationTime);

	watch(
		() => userStore.isLoggedIn,
		async () => {
			await userStore.loadInfo();

			if (!userStore.isLoggedIn || userStore.userInfo.emailVerified) {
				showBanner.value = false;
			}

			if (userStore.isLoggedIn && !userStore.isAccountVerified && !showBanner.value) {
				showBanner.value = true;
			}
		},
		{ immediate: true }
	);

	return {
		showBanner,
		userCreationTime,
	};
}
